import { newMeasureValueFilter, newPositiveAttributeFilter } from "@gooddata/sdk-model";
import { ErrorComponent, useExecutionDataView } from "@gooddata/sdk-ui";
import React, { useEffect, useState, useContext } from "react";
import { useAppContext } from "../../contexts/AppContext";
import FiltersContext from "../../contexts/Filters";
import MeasuresContext, { flagServiceM } from "../../contexts/Measures";
import * as Md from "../../md/full";
import LoadingSpinner from "../LoadingSpinner";
import Widget from "../Widget";
import Exportbtn from "../Export/Exportbtn";
import Export from "./Export";
import ComboBoxScopeFilter from "../ComboBoxScopeFilter";
import ExtendedTable from "./ExtendedTable";
import CondensedTable from "./CondensedTable";
import { generatePdf } from "../../utils/pdfGenerator";
import LoadingPopup from "../LoadingPopup";
import { notification } from "antd";
import { useUserContext, settingsAliases } from "../../contexts/User";

const Services = (settings, IncServices) => {
    const services =
        settings &&
        Object.keys(settings)
            ?.filter((key) => settings[key] === 1)
            .map((key) => settingsAliases[key]);
    return IncServices ? (services?.length > 0 ? `${services.join(", ")}` : "No Services") : "No Services";
};

const UKOEM = () => {
    const [offers, setOffers] = useState([]);
    const [bestOffers, setBestOffers] = useState([]);
    const [AprNull, setAprNull] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [exportData, setExportData] = useState([]);
    const { getCountryByCode, showExtendedTable } = useAppContext();
    const { getFiltersForFootnote } = useContext(FiltersContext);
    const { seriesBy } = useContext(MeasuresContext);
    const { enabledKpisettings, IncServices } = useUserContext();
    const {
        filterMthCode,
        filterCountryId,
        filterChannel1,
        filterChannel3,
        filterMake,
        filterModel,
        filterFuel,
        filterCustLabel,
        filterVehType,
        filterVehSegment,
        filterBody,
        filterTrim,
        filterDrive,
        filterGearPlus,
        filterSize,
        filterListPrice,
        filterPs,
        filterKw,
        filterCo2,
        filterCustmix,
        filterVersionStd,
        filterDuration,
        getFirstFilterValue,
        updateFilter,
        currentFilter,
    } = useContext(FiltersContext);

    const ctryid = filterCountryId.positiveAttributeFilter.in["values"][0];

    const commonFilters = [
        filterMthCode,
        filterCountryId,
        filterChannel1,
        filterChannel3,
        newPositiveAttributeFilter(Md.Extraptype, ["No Extrapolation"]),
        filterMake,
        filterModel,
        filterFuel,
        newPositiveAttributeFilter(Md.CustId, ["3PO", "OEB"]),
        filterCustLabel,
        filterVehType,
        filterVehSegment,
        filterBody,
        filterTrim,
        filterDrive,
        filterGearPlus,
        filterSize,
        filterListPrice,
        filterPs,
        filterKw,
        filterCo2,
        filterCustmix,
        newPositiveAttributeFilter(Md.Rolledforward, ["No"]),
        filterVersionStd,
    ];

    const oemFilters = [...commonFilters, filterDuration, ...(AprNull ? [newMeasureValueFilter(Md.Apr.Avg, "EQUAL_TO", 0)] : [])];

    const exportfilters = [...commonFilters, ...(AprNull ? [newMeasureValueFilter(Md.Apr.Avg, "EQUAL_TO", 0)] : [])];
    const { result, status } = useExecutionDataView({
        execution: {
            seriesBy: [...seriesBy, Md.Deposit.Avg, Md.Doors.Avg, Md.Apr.Avg],
            // seriesBy: [Md.ListPrice.Avg, Md.Rental.Avg, Md.Deposit.Avg, Md.Co2malus.Avg, Md.Kw.Avg, Md.Ps.Avg, seriesBy],
            slicesBy: [Md.VersionStd, Md.CorrMake, Md.Fuel, Md.Channel3, Md.Duration, Md.Channel2, Md.CorrModel, Md.VehSegment, Md.BodyStyle, Md.TrimName, Md.Version, Md.GearsPlus, Md.Drive, Md.Warning, Md.Url],
            filters: [...oemFilters],
        },
    });
    const columns = [
        {
            title: "Vehicle",
            key: "Vehicle",
            type: "String",
        },
        {
            title: "List_Price",
            key: "List_Price",
            type: "Numeric",
        },
        {
            title: "Channel",
            key: "Channel",
            type: "String",
        },
        {
            title: "Finance_Type",
            key: "Finance_Type",
            type: "String",
        },
        {
            title: "Months",
            key: "Months",
            type: "Numeric",
        },
        {
            title: "Mileage",
            key: "Mileage",
            type: "Numeric",
        },
        {
            title: "Web_Rental",
            key: "Web_Rental",
            type: "Numeric",
        },
        {
            title: "Web_Deposit",
            key: "Web_Deposit",
            type: "Numeric",
        },
        {
            title: "Interest_Rate",
            key: "Interest_Rate",
            type: "Numeric",
        },
        {
            title: "RV",
            key: "RV",
            type: "Numeric",
        },
        {
            title: "Adj_Rental",
            key: "Adj_Rental",
            type: "Numeric",
        },
        {
            title: "Leasing_Factor",
            key: "Leasing_Factor",
            type: "Numeric",
        },
        {
            title: "Web_Rental_Includes",
            key: "Web_Rental_Includes",
            type: "String",
        },
        {
            title: "Adj_Rental_Includes",
            key: "Adj_Rental_Includes",
            type: "String",
        },
        {
            title: "Make",
            key: "Make",
            type: "String",
        },
        {
            title: "Model",
            key: "Model",
            type: "String",
        },
        {
            title: "Energy",
            key: "Energy",
            type: "String",
        },
        {
            title: "Trim",
            key: "Trim",
            type: "String",
        },
        {
            title: "Vehicle_Segment",
            key: "Vehicle_Segment",
            type: "String",
        },
        {
            title: "Body_Type",
            key: "Body_Type",
            type: "String",
        },
        {
            title: "Gearbox",
            key: "Gearbox",
            type: "String",
        },
        {
            title: "Doors",
            key: "Doors",
            type: "Numeric",
        },
        {
            title: "Power",
            key: "Power",
            type: "Numeric",
        },
        {
            title: "Drive",
            key: "Drive",
            type: "String",
        },
        {
            title: "Version",
            key: "Version",
            type: "String",
        },
        {
            title: "Comment",
            key: "Comment",
            type: "String",
        },
    ];

    function sortColumn(column, sortOrder) {
        let comparator;
        if (column.type === "String") {
            comparator = sortOrder === "asc" ? (a, b) => a[column.key].localeCompare(b[column.key]) : (a, b) => b[column.key].localeCompare(a[column.key]);
        } else {
            comparator = sortOrder === "asc" ? (a, b) => a[column.key] - b[column.key] : (a, b) => b[column.key] - a[column.key];
        }
        const sortedData = offers.sort(comparator);
        setOffers([...sortedData]);
    }
    function sortBestOffers(column, sortOrder) {
        let comparator;
        if (column.type === "String") {
            comparator = sortOrder === "asc" ? (a, b) => a[column.key].localeCompare(b[column.key]) : (a, b) => b[column.key].localeCompare(a[column.key]);
        } else {
            comparator = sortOrder === "asc" ? (a, b) => a[column.key] - b[column.key] : (a, b) => b[column.key] - a[column.key];
        }
        const sortedData = bestOffers.sort(comparator);
        setBestOffers([...sortedData]);
    }

    const ServicesMessage = IncServices ? `${Services(enabledKpisettings, IncServices)}` : "No Services";

    useEffect(() => {
        //First Part of Data
        setIsLoading(true);
        const slices = result?.data()?.slices()?.toArray();
        if (slices) {
            const data = slices.map((slice) => {
                const services = Object.entries(enabledKpisettings).reduce((acc, [flag, val]) => {
                    if (val === 1) {
                        return {
                            ...acc,
                            [settingsAliases[flag]]: Number(slice.dataPoints()[flagServiceM[flag].flIndex].rawValue),
                        };
                    }
                    return acc;
                }, {});
                return {
                    Vehicle: slice.sliceTitles()[0],
                    List_Price: Number(slice.dataPoints()[1].rawValue) > 0 ? Number(Number(slice.dataPoints()[1].rawValue).toFixed(0)) : null,
                    Channel: slice.sliceTitles()[5],
                    Finance_Type: slice.sliceTitles()[3],
                    Months: Number(slice.sliceTitles()[4].split("/")[0]),
                    Mileage: Number(slice.sliceTitles()[4].split("/")[1]),
                    Web_Rental: Number(slice.dataPoints()[3].rawValue) > 0 ? Number(Number(slice.dataPoints()[3].rawValue).toFixed(0)) : null,
                    Web_Deposit: Number(slice.dataPoints()[38].rawValue) > 0 ? Number(Number(slice.dataPoints()[38].rawValue).toFixed(0)) : 0,
                    Interest_Rate: slice.dataPoints()[40].rawValue === "0" ? 0 + "%" : Number(slice.dataPoints()[40].rawValue) > 0 ? Number(100 * Number(slice.dataPoints()[40].rawValue)).toFixed(2) + "%" : null,
                    RV: Number(slice.dataPoints()[25].rawValue) > 0 ? Number(Number(slice.dataPoints()[25].rawValue).toFixed(0)) : null,
                    Web_Rental_Includes:
                        Object.entries(services)
                            .filter((m) => m[1] === 1)
                            .map((m) => m[0])
                            .join(", ") || "No Services",
                    Adj_Rental: Number(slice.dataPoints()[23].rawValue) > 0 ? Number(Number(slice.dataPoints()[23].rawValue).toFixed(0)) : null,
                    Leasing_Factor: Number(slice.dataPoints()[1].rawValue) > 0 ? Number((100 * Number(slice.dataPoints()[24].rawValue)).toFixed(2)) : null,
                    Adj_Rental_Includes: ServicesMessage,
                    Make: slice.sliceTitles()[1],
                    Model: slice.sliceTitles()[6],
                    Energy: slice.sliceTitles()[2],
                    Trim: slice.sliceTitles()[9],
                    Vehicle_Segment: slice.sliceTitles()[7],
                    Body_Type: slice.sliceTitles()[8],
                    Gearbox: slice.sliceTitles()[11],
                    Doors: Number(slice.dataPoints()[39].rawValue),
                    Power: Number(slice.dataPoints()[22].rawValue),
                    Drive: slice.sliceTitles()[12],
                    Version: slice.sliceTitles()[10],
                    Comment: slice.sliceTitles()[13],
                    Url: slice.sliceTitles()[14],
                };
            });
            // find duplicates versions
            const duplicates = data.filter((item, index) => data.findIndex((i) => i.Vehicle === item.Vehicle) !== index);
            // remove duplicates that have no ajusted rental or leasing factor
            const dataWithoutDuplicates = data.filter((item) => duplicates.findIndex((i) => i.Vehicle === item.Vehicle) === -1 || (item["Adj. Rental"] !== null && item["Leasing Factor"] !== null));

            const datatoExport = slices.map((slice) => {
                const services = Object.entries(enabledKpisettings).reduce((acc, [flag, val]) => {
                    if (val === 1) {
                        return {
                            ...acc,
                            [settingsAliases[flag]]: Number(slice.dataPoints()[flagServiceM[flag].flIndex].rawValue),
                        };
                    }
                    return acc;
                }, {});
                return {
                    Vehicle: slice.sliceTitles()[0],
                    List_Price: Number(slice.dataPoints()[1].rawValue) > 0 ? Number(Number(slice.dataPoints()[1].rawValue).toFixed(0)) : null,
                    Channel: slice.sliceTitles()[5],
                    Finance_Type: slice.sliceTitles()[3],
                    Months: Number(slice.sliceTitles()[4].split("/")[0]),
                    Mileage: Number(slice.sliceTitles()[4].split("/")[1]),
                    Web_Rental: Number(slice.dataPoints()[3].rawValue) > 0 ? Number(Number(slice.dataPoints()[3].rawValue).toFixed(0)) : null,
                    Web_Deposit: Number(slice.dataPoints()[38].rawValue) > 0 ? Number(Number(slice.dataPoints()[38].rawValue).toFixed(0)) : 0,
                    Interest_Rate: slice.dataPoints()[40].rawValue === "0" ? 0 + "%" : Number(slice.dataPoints()[40].rawValue) > 0 ? Number(100 * Number(slice.dataPoints()[40].rawValue)).toFixed(2) + "%" : null,
                    RV: Number(slice.dataPoints()[25].rawValue) > 0 ? Number(Number(slice.dataPoints()[25].rawValue).toFixed(0)) : null,
                    Web_Rental_Includes:
                        Object.entries(services)
                            .filter((m) => m[1] === 1)
                            .map((m) => m[0])
                            .join(", ") || "No Services",
                    Adj_Rental: Number(slice.dataPoints()[23].rawValue) > 0 ? Number(Number(slice.dataPoints()[23].rawValue).toFixed(0)) : null,
                    Leasing_Factor: Number(slice.dataPoints()[1].rawValue) > 0 ? Number((100 * Number(slice.dataPoints()[24].rawValue)).toFixed(2)) : null,
                    Adj_Rental_Includes: ServicesMessage,
                    Make: slice.sliceTitles()[1],
                    Model: slice.sliceTitles()[6],
                    Energy: slice.sliceTitles()[2],
                    Trim: slice.sliceTitles()[9],
                    Vehicle_Segment: slice.sliceTitles()[7],
                    Body_Type: slice.sliceTitles()[8],
                    Gearbox: slice.sliceTitles()[11],
                    Doors: Number(slice.dataPoints()[39].rawValue),
                    Power: Number(slice.dataPoints()[22].rawValue),
                    Drive: slice.sliceTitles()[12],
                    Version: slice.sliceTitles()[10],
                    Comment: slice.sliceTitles()[13],
                    Url: slice.sliceTitles()[14],
                };
            });
            setExportData(datatoExport);

            setOffers(dataWithoutDuplicates);
            //Best Offers >> Conditions : Leasing Factor > 0, lowest 5 leasing factor offers, segment lenght = 1
            const bestOffers = dataWithoutDuplicates
                ?.filter((item) => item["Leasing_Factor"] > 0 && item.Vehicle_Segment.length === 1)
                .sort((a, b) => a["Leasing_Factor"] - b["Leasing_Factor"])
                .slice(0, 5);
            setBestOffers(bestOffers);
            setIsLoading(false);
        }
    }, [result, AprNull, enabledKpisettings, IncServices]);

    const stickyColumn = "Vehicle";
    const columnGroups = [
        { title: "", span: 1, className: "sticky left-0 bg-gray-100" },
        {
            title: "Promotion",
            span: 11,
            className: "px-4 py-2 text-xs text-white bg-indigo-700",
        },
        {
            title: "Promotion Details",
            span: 14,
            className: "px-4 py-2 text-xs text-white bg-indigo-500",
        },
    ];
    const CondensedColumns = [
        {
            title: "Vehicle",
            key: "Vehicle",
            type: "String",
        },
        {
            title: "List_Price",
            key: "List_Price",
            type: "Numeric",
        },
        {
            title: "Channel",
            key: "Channel",
            type: "String",
        },
        {
            title: "Fin_Type",
            key: "Finance_Type",
            type: "String",
        },
        {
            title: "Months",
            key: "Months",
            type: "Numeric",
        },
        {
            title: "Mileage",
            key: "Mileage",
            type: "Numeric",
        },
        {
            title: "Web_Rental",
            key: "Web_Rental",
            type: "Numeric",
        },
        {
            title: "Web_Dep",
            key: "Web_Deposit",
            type: "Numeric",
        },
        {
            title: "Adj_Rental",
            key: "Adj_Rental",
            type: "Numeric",
        },
        {
            title: "Web_Rental_Includes",
            key: "Web_Rental_Includes",
            type: "String",
        },
        {
            title: "LF",
            key: "Leasing_Factor",
            type: "Numeric",
        },
    ];

    const [isGenerating, setIsGenerating] = useState(false);
    const [pdfProgress, setPdfProgress] = useState(0);

    const handleGeneratePdf = async () => {
        try {
            setIsGenerating(true);
            setPdfProgress(0);
            //@ts-ignore
            const title = `Promotions - ${getCountryByCode(filterCountryId.positiveAttributeFilter.in?.values[0])} - ${filterChannel1?.positiveAttributeFilter?.in["values"][0]} - ${filterMthCode?.positiveAttributeFilter?.in["values"][0]}`;
            const subtitle = `OEM promotional offers of the month as published on the websites${getFirstFilterValue("filterDuration") ? ` (filtered by ${getFirstFilterValue("filterDuration")} months)` : ""}${AprNull ? " with APR = 0%" : ""}`;

            await generatePdf({
                data: offers,
                title,
                subtitle,
                onProgress: (progress) => setPdfProgress(progress),
            });
        } catch (error) {
            notification.error({
                message: "PDF Generation Failed",
                description: error.message || "Please try again with fewer records or contact support.",
            });
        } finally {
            setIsGenerating(false);
            setPdfProgress(0);
        }
    };

    return (
        <div>
            <div className="flex flex-row items-center mb-8">
                <div className="flex flex-row  gap-8 items-center">
                    <div className="flex flex-row gap-4 items-center">
                        <span className="font-bold text-indigo-700">Duration:</span>
                        <ComboBoxScopeFilter title={"Duration"} value={getFirstFilterValue("filterDuration")} filterAttribute={filterDuration} mdAttribute={Md.Duration} filterID={"filterDuration"} currentFilter={currentFilter} onUpdateFilter={updateFilter} />
                    </div>
                    <div className="flex flex-row gap-4 items-center">
                        <input type="checkbox" className="accent-indigo-700 cursor-pointer w-4 h-4" checked={AprNull} onChange={() => setAprNull(!AprNull)} />
                        <span className="font-medium text-gray-500 text-medium cursor-pointer hover:opacity-80" onClick={() => setAprNull(!AprNull)}>
                            {"  "}
                            Filter with APR ( Interest Rate ) = 0 %{" "}
                        </span>{" "}
                    </div>
                    {!showExtendedTable && (
                        <button onClick={handleGeneratePdf} disabled={isGenerating} className="flex text-white bg-indigo-700 px-12 py-1 border hover:bg-indigo-500 border-indigo-700 rounded font-semibold shadow-button disabled:opacity-50 disabled:cursor-not-allowed">
                            {isGenerating ? "Generating..." : "Generate PDF"}
                        </button>
                    )}
                    <Exportbtn onclick={() => setModalVisible(true)} />
                </div>
            </div>
            {isLoading && <LoadingSpinner />}
            {status === "error" && <ErrorComponent message={`No Data available for your current filters`} description="If 'Promotions' is not activated in your workspace, Please contact experteye support." />}
            {status === "success" && isLoading === false && (
                <div className="flex flex-col gap-8">
                    {/* // best offers table */}
                    {showExtendedTable && (
                        <div>
                            <Widget
                                //@ts-ignore
                                title={`Top 5 promotions of the month — ${getCountryByCode(filterCountryId.positiveAttributeFilter.in?.values[0])} | ${filterChannel1?.positiveAttributeFilter?.in["values"][0]} | ${filterMthCode?.positiveAttributeFilter?.in["values"][0]}`}
                                description="This section share the best 5 offers of the month as published on the websites"
                                footnote={getFiltersForFootnote()}
                            >
                                {/*@ts-ignore*/}
                                {showExtendedTable ? (
                                    <ExtendedTable data={bestOffers} columns={columns} columnGroups={columnGroups} onSort={sortBestOffers} stickyColumn={stickyColumn} />
                                ) : (
                                    <CondensedTable columns={CondensedColumns} data={bestOffers} onSort={sortBestOffers} stickyColumn={stickyColumn} />
                                )}
                            </Widget>
                        </div>
                    )}
                    {/* // all offers table */}
                    <Widget
                        //@ts-ignore
                        title={`Promotions — ${getCountryByCode(filterCountryId.positiveAttributeFilter.in?.values[0])} | ${filterChannel1?.positiveAttributeFilter?.in["values"][0]} | ${filterMthCode?.positiveAttributeFilter?.in["values"][0]}`}
                        description={"This section shares OEM promotional offers of the month as published on the websites"}
                        footnote={getFiltersForFootnote()}
                    >
                        {/*@ts-ignore*/}
                        {showExtendedTable ? <ExtendedTable data={offers} columns={columns} columnGroups={columnGroups} onSort={sortColumn} stickyColumn={stickyColumn} /> : <CondensedTable columns={CondensedColumns} data={offers} onSort={sortColumn} stickyColumn={stickyColumn} />}
                    </Widget>
                </div>
            )}
            {/*@ts-ignore*/}
            <Export filters={exportfilters} seriesBy={seriesBy} data={exportData} modalVisible={modalVisible} setModalVisible={setModalVisible} countryId={filterCountryId.positiveAttributeFilter.in?.values[0]} />
            <LoadingPopup isOpen={isGenerating} message="Generating PDF Report" progress={pdfProgress} />
        </div>
    );
};

export default UKOEM;
